import { UploadManager } from '@bytescale/sdk';

import { apiKey } from '../../../utils';

/**
 * Katalog w Bytescale dla materiałów generatora reklam. Osobny od `<bucket>/ads`
 * (grafiki reklam wyświetlanych gościom), bo to inny obieg: tamte trafiają na
 * urządzenia w hotelach, te są warsztatem marketingu Hotelspota.
 */
export const ADS_FOLDER_PATH = '/hotelspot-admin-ads';

export interface UploadedFile {
  url: string;
  filePath: string;
  mime: string;
  size: number;
}

let manager: UploadManager | null = null;

const getManager = (): UploadManager => {
  if (!apiKey) {
    throw new Error(
      'Brak klucza Bytescale w konfiguracji panelu (REACT_APP_BYTESCALE_API_KEY). '
      + 'Bez niego nie da się wgrać pliku.',
    );
  }
  if (!manager) manager = new UploadManager({ apiKey });
  return manager;
};

/**
 * Wysyła plik do Bytescale i oddaje jego trwały adres.
 *
 * Bajty idą z przeglądarki wprost do CDN, z pominięciem naszego backendu:
 * klucz publiczny pozwala na upload, więc nie ma powodu przepuszczać kilku
 * megabajtów przez funkcję. Do Firestore trafia potem sam adres.
 */
export const uploadToBytescale = async (data: Blob, fileName: string): Promise<UploadedFile> => {
  try {
    const result = await getManager().upload({
      data,
      mime: data.type || 'application/octet-stream',
      originalFileName: fileName,
      path: { folderPath: ADS_FOLDER_PATH },
    });

    return {
      url: result.fileUrl,
      filePath: result.filePath,
      mime: result.mime ?? data.type,
      size: result.size ?? data.size,
    };
  } catch (error) {
    // Komunikat z SDK bywa techniczny, więc dokładamy kontekst: bez niego
    // w panelu widać tylko „Request failed" i nie wiadomo, co zawiodło.
    const detail = error instanceof Error ? error.message : String(error);
    throw new Error(`Wysyłka pliku do Bytescale nie powiodła się: ${detail}`);
  }
};
